import Snackbar from '@material-ui/core/Snackbar';
import React from 'react';
import MUIAlert from '@material-ui/lab/Alert';
import { GLOBAL_VALUES } from '../../constants';
import { clearGloablMessage } from '../../reducers/app';
import { connect } from 'react-redux';

function AppGlobalAlert(props) {
    const {
        message,
        messageType,
        clearGloablMessage
    } = props;

    const open = message || message ? true : false;
    const severity = messageType;

    const onAlertClose = () => {
        clearGloablMessage();
    }

    return (message ? <Snackbar open={open} anchorOrigin={
        { vertical: 'top', horizontal: 'center' }
    } autoHideDuration={GLOBAL_VALUES.ALERT_AUTO_HIDE_TIMEOUT} onClose={onAlertClose}>
        <MUIAlert open={open}
            severity={severity}
            onClose={onAlertClose}>
            {message}
        </MUIAlert>
    </Snackbar> : null);
}


const mapStateToProps = state => ({
    message: state.APP_DATA.message,
    messageType: state.APP_DATA.messageType
});

const mapDispatchToProps = dispatch => ({
    clearGloablMessage: () => dispatch(clearGloablMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppGlobalAlert);